import { DomSanitizer } from "@angular/platform-browser";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-order-detail",
  templateUrl: "./order-detail.component.html",
  styleUrls: ["./order-detail.component.css"],
})
export class OrderDetailComponent implements OnInit {
  @Input() title: string;
  @Input() message: any;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  orderItems: any;
  constructor(
    private activeModal: NgbActiveModal,
    public _DomSanitizationService: DomSanitizer
  ) {}

  ngOnInit() {
    this.orderItems = this.message;
  }

  getSubTotal(price, quantity) {
    let returnPrice = parseFloat(price) * parseFloat(quantity);
    return parseFloat(returnPrice.toString()).toFixed(2);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
